import { ReactNode } from "react";
import { Redirect } from "wouter";
import { useAuth } from "@/hooks/use-auth";

interface WorkspaceAdminOnlyRouteProps {
  children: ReactNode;
}

export function WorkspaceAdminOnlyRoute({
  children,
}: WorkspaceAdminOnlyRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00444C]"></div>
      </div>
    );
  }

  // Platform admins should use /admin/* routes
  if (user && user.role === "admin") {
    return <Redirect to="/admin/dashboard" />;
  }

  if (user && user.role === "sales_person") {
    return <Redirect to="/sales/dashboard" />;
  }

  if (user && user.role === "portfolio_manager") {
    return <Redirect to="/portfolio" />;
  }

  // Members (non-workspace admins) can only access /assessments
  if (user && user.workspaceRole !== "workspace_admin") {
    return <Redirect to="/assessments" />;
  }

  return <>{children}</>;
}
